// Number of historical years the abiotic model aggregates for each
// Stress Frequency dropdown option. Keys are the values stored in
// flow.selectedAbioticFrequencyValue.
export const AbioticFrequencyYears: Record<string, number> = {
  last20: 20,
  last10: 10,
  last5: 5,
};

export const DEFAULT_ABIOTIC_FREQUENCY_VALUE = 'last5';

export const DEFAULT_ABIOTIC_FREQUENCY_YEARS =
  AbioticFrequencyYears[DEFAULT_ABIOTIC_FREQUENCY_VALUE];
